import { render, staticRenderFns } from "./advert1.vue?vue&type=template&id=0bf9147e&scoped=true"
import script from "./advert1.vue?vue&type=script&lang=js"
export * from "./advert1.vue?vue&type=script&lang=js"
import style0 from "./advert1.vue?vue&type=style&index=0&id=0bf9147e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf9147e",
  null
  
)

export default component.exports